import {
  MDBBtn,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBRow,
  MDBAutocomplete
} from "mdb-react-ui-kit";
import React, { useEffect, useState, useRef } from "react";
import { Tooltip } from "react-tooltip";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import PopupLoader from "../../PopupLoader";
import { LocAddressSeach } from "../../../../apiclients/streamsapi_bridge";


function BrandDetails({ register, watch, errors, setValue, clearErrors, isLoading, setIsLoading }) {
  const navigate = useNavigate();
  const [countryMainList, setcountryMainList] = useState([]);
  const [countryList, setcountryList] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [stockExchangeList, setstockExchangeList] = useState([]);
  const [industryTypes, setindustryTypes] = useState([]);
  const [legalTypes, setlegalTypes] = useState([]);
  const [dunsgiinleiList, setdunsgiinleiList] = useState({});
  const [displayalert, setdisplayalert] = useState(false);
  const alertToggle = () => setdisplayalert(!displayalert);
  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [typingTimeout, setTypingTimeout] = useState(null);


  useEffect(() => {
    getBrandMisc();
  }, []);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("brand_details.street");
      setValue("brand_details.street", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };
  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("brand_details.street", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("brand_details.city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = stateList.find(
        (state) => state.statecode.trim() === address.state.trim()
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("brand_details.state", stateObj.sid, {
          shouldDirty: true,
        });
      }
    }
    if (address.zipcode) {
      setValue("brand_details.zipcode", address.zipcode, { shouldDirty: true });
    }
  }

  async function getBrandMisc() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["brand_registration"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
    // setSourceNumber(basicInfo.misc.free_dids);
    setcountryMainList(basicInfo?.misc?.brand_registration?.country_list ?? []);
    setcountryList(basicInfo?.misc?.brand_registration?.country_list ?? []);
    setstateList(basicInfo?.misc?.brand_registration?.state_list ?? []);
    setindustryTypes(
      basicInfo?.misc?.brand_registration?.acc_industry_type_list ?? []
    );
    setstockExchangeList(
      basicInfo?.misc?.brand_registration?.stock_exchange_list ?? []
    );
    setlegalTypes(basicInfo?.misc?.brand_registration?.acc_org_type_list ?? []);
    setdunsgiinleiList(
      basicInfo?.misc?.brand_registration?.duns_giin_lei ?? {}
    );
  }

  function handleOrganizationChange(e) {
    e.preventDefault();
    setValue("brand_details.org_type", parseInt(e.target.value), {
      shouldDirty: true,
    });
    if (parseInt(e.target.value) === 5) {
      setValue("brand_details.country", "US", { shouldDirty: true });
      setcountryList(
        countryMainList.filter((country) => country.cscode === "US")
      );
    } else {
      setcountryList([...countryMainList]);
      if (parseInt(e.target.value) === 4) {
        alertToggle();
      }
    }
  }

  function handleOk(e) {
    e.preventDefault();
    setValue("brand_details.org_type", 0, {
      shouldDirty: true,
    });
    alertToggle();
  }
  return (
    <>
      <MDBRow className="h-100">
        <MDBCol size="12" className="pe-0 mob-w-100">
          <div>
            <p className="mt-1">
              The Privacy Policy is required to be on your company’s website. If
              you are providing a social media business page as their online
              presence, then you must have both the privacy policy and SMS
              disclaimer pinned to the top of the social media business page.
            </p>

            <p className="mt-1">
              <strong>Privacy Policy:</strong> No mobile information will be
              shared with third parties/affiliates for marketing/promotional
              purposes. All the above categories exclude text messaging
              originator Opt-in data and consent; this information will not be
              shared with any third parties.
            </p>
            <p className="mt-1">
              <strong>SMS Disclaimer:</strong> By providing a telephone number
              and submitting the form you are consenting to be contacted by SMS
              text message (our message frequency may vary). Message & data
              rates may apply. Reply STOP to Opt-out of further messaging. Reply
              HELP for more information. See our Privacy Policy.
            </p>
            <hr />

            <div className="mt-3">
              <h5 className="my-3 p-3 bg-light-200">Brand Details:</h5>
            </div>
          </div>

          <div className="pb-1">
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>Legal Company Name *</strong>
                </div>
                <div className="d-flex align-items-center">
                  <MDBInput
                    type="text"
                    {...register("brand_details.company_name", {
                      required: "Legal Company Name is required",
                    })}
                  />
                 
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 LegalCompany cursor-pointer ms-3"
                  />
                </div>
                 {errors?.brand_details?.company_name && (
                    <p className="text-danger">
                      {errors?.brand_details?.company_name?.message}
                    </p>
                  )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>
                    DBA or Brand Name, if different from legal name *
                  </strong>
                </div>
                <div className="d-flex align-items-center">
                  <MDBInput
                    type="text"
                    {...register("brand_details.brand_name", {
                      required: "DBA or Brand Name is required",
                    })}
                  />
                  
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 DBAorBrandName cursor-pointer ms-3"
                  />
                </div>
                {errors?.brand_details?.brand_name && (
                    <p className="text-danger">
                      {errors?.brand_details?.brand_name?.message}
                    </p>
                  )}
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>Country of Registration *</strong>
                </div>
                <div className="d-flex align-items-center">
                  <select
                    className="w-95 form-select"
                    {...register("brand_details.country", {
                      required: "Country of Registration is required",
                    })}
                  >
                    <option value="">-- Select Country --</option>
                    {countryList.map((country) => (
                      <option value={country.cscode}>{country.cname}</option>
                    ))}
                  </select>
                 
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 CountryofRegistration cursor-pointer ms-3"
                  />
                </div>
                 {errors?.brand_details?.country && (
                    <p className="text-danger">
                      {errors?.brand_details?.country?.message}
                    </p>
                  )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>
                    What type of legal form is the organization? *
                  </strong>
                </div>

                <select
                  className="w-95 form-select"
                  {...register("brand_details.org_type", {
                    required: "organization Name is required",
                  })}

                  value={watch("brand_details.org_type")}
                  onChange={(e) => handleOrganizationChange(e)}
                >
                  <option value={0}>-- Select Organization Type --</option>
                  {legalTypes.map((type) => (
                    <option value={type.org_type_id}>
                      {type.org_type_name}
                    </option>
                  ))}
                </select>
                {errors?.brand_details?.org_type && (
                  <p className="text-danger">
                    {errors?.brand_details?.org_type?.message}
                  </p>
                )}
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>Tax Number/ID/EIN *</strong>
                </div>
                <div className="d-flex align-items-center">
                  <MDBInput
                    type="text"
                    {...register("brand_details.tax_number", {
                      required: "Tax Number/ID/EIN is required",
                    })}
                  />
                 
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 TaxNumber cursor-pointer ms-3"
                  />
                </div>
                 {errors?.brand_details?.tax_number && (
                    <p className="text-danger">
                      {errors?.brand_details?.tax_number?.message}
                    </p>
                  )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>DUNS or GIIN or LEI Number *</strong>
                </div>
                <div className="d-flex align-items-center">
                  <select
                    className="w-95 form-select"
                    {...register("brand_details.duns_giin_lei", {
                      required: "DUNS or GIIN or LEI Number is required",
                    })}
                  >
                    {Object.entries(dunsgiinleiList).map(([key, value]) => (
                      <option value={value}>{key}</option>
                    ))}
                  </select>
                  
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 DUNSorGIIN cursor-pointer ms-3"
                  />
                  
                </div>
                {errors?.brand_details?.duns_giin_lei && (
                    <p className="text-danger">
                      {errors?.brand_details?.duns_giin_lei?.message}
                    </p>
                  )}
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="w-95">
                  <div className="tel-numbers">
                    <strong>Address/Street *</strong>
                  </div>
                  {/* <MDBInput
                    type="text"
                    {...register("brand_details.street", {
                      required: "Address/Street is required",
                    })}
                  /> */}
                  <MDBAutocomplete
                    data={addressReasults}
                    // value={addressValue}
                    value={watch("brand_details.street")}
                    displayValue={(address) => address.street_line}
                    isLoading={isLoading}
                    // open={isDisplay}
                    placeholder="Address 1"
                    onSearch={handleSearchAddressChange}
                    onSelect={(e) => {
                      allowAPI.current = false;
                      setisDisplay(false);
                    }}
                    itemContent={(address) => (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          allowAPI.current = false;
                          handleAddressSelect(address);
                        }}
                      >
                        {address.street_line || ""}
                        {address.secondary ? ", " + address.secondary : ""}
                        {address.city ? ", " + address.city : ""}
                        {address.state ? ", " + address.state : ""}
                        {address.zipcode ? ", " + address.zipcode : ""}
                      </div>
                    )}
                     {...register("brand_details.street", {
                      required: "Address/Street is required",
                    })}
                  />
                  
                </div>
                {errors?.brand_details?.street && (
                    <p className="text-danger">
                      {errors?.brand_details?.street?.message}
                    </p>
                  )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>DUNS Number </strong>
                </div>
                <div className="d-flex align-items-center">
                  <MDBInput
                    type="text"
                    {...register("brand_details.duns_giin_lei_num")}
                  />
                 
                  <MDBIcon
                    fas
                    icon="info-circle"
                    className="fs-5 DUNSNumber cursor-pointer ms-3"
                  />
                   
                </div>
                {errors?.brand_details?.duns_giin_lei_num && (
                    <p className="text-danger">
                      {errors?.brand_details?.duns_giin_lei_num?.message}
                    </p>
                  )}
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="w-95">
                  <div className="tel-numbers">
                    <strong>City *</strong>
                  </div>
                  <MDBInput
                    type="text"
                    {...register("brand_details.city", {
                      required: "City is required",
                    })}
                  />
                  {errors?.brand_details?.city && (
                    <p className="text-danger">
                      {errors?.brand_details?.city?.message}
                    </p>
                  )}
                </div>
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>State/Region *</strong>
                </div>

                <select
                  className="w-95 form-select"
                  {...register("brand_details.state", {
                    required: "State is required",
                  })}
                >
                  <option value = {0}>-- Select State --</option>
                  {stateList.map((state) => (
                    <option value={state.sid}>{state.sname}</option>
                  ))}
                </select>
                {errors?.brand_details?.state && (
                  <p className="text-danger">
                    {errors?.brand_details?.state?.message}
                  </p>
                )}
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="w-95">
                  <div className="tel-numbers">
                    <strong>Postal Code/Zip Code *</strong>
                  </div>
                  <MDBInput
                    type="text"
                    {...register("brand_details.zipcode", {
                      required: "Postal Code/Zip Code is required",
                    })}
                  />
                  {errors?.brand_details?.zipcode && (
                    <p className="text-danger">
                      {errors?.brand_details?.zipcode?.message}
                    </p>
                  )}
                </div>
              </MDBCol>
              <MDBCol size={6}>
                <div className="w-95">
                  <div className="tel-numbers">
                    <strong>Website *</strong>
                  </div>
                  <MDBInput
                    type="text"
                    {...register("brand_details.website", {
                      required: "Website is required",
                    })}
                  />
                  {errors?.brand_details?.website && (
                    <p className="text-danger">
                      {errors?.brand_details?.website?.message}
                    </p>
                  )}
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow className="my-1">
              <MDBCol size={6}>
                <div className="tel-numbers">
                  <strong>Industry Type *</strong>
                </div>

                <select
                  className="w-95 form-select"
                  {...register("brand_details.vertical_type", {
                    required: "Industry Type is required",
                  })}
                >
                  <option value={0}>-- Select Industry Type --</option>
                  {industryTypes.map((industry) => (
                    <option value={industry.industry_type_id}>
                      {industry.industry_type}
                    </option>
                  ))}
                </select>
                {errors?.brand_details?.vertical_type && (
                  <p className="text-danger">
                    {errors?.brand_details?.vertical_type?.message}
                  </p>
                )}
              </MDBCol>
              {watch("brand_details.org_type") == 1 && (
                <MDBCol size={6}>
                  <div className="tel-numbers">
                    <strong>Stock Exchange *</strong>
                  </div>

                  <select
                    className="w-95 form-select"
                    {...register("brand_details.stock_exchange", {
                      setValueAs: (value) => Number(value),
                      required: "Stock Exchange is required",
                    })}
                  >
                    <option value="">- Select Stock Exchange -</option>
                    {stockExchangeList.map((stock) => (
                      <option value={stock.stock_id}>{stock.stock_name}</option>
                    ))}
                  </select>
                  {errors?.brand_details?.stock_exchange && (
                    <p className="text-danger">
                      {errors?.brand_details?.stock_exchange?.message}
                    </p>
                  )}
                </MDBCol>
              )}
            </MDBRow>
            <MDBRow className="my-1">
              {watch("brand_details.org_type") == 1 && (
                <MDBCol size={6}>
                  <div className="w-95">
                    <div className="tel-numbers">
                      <strong>Stock Symbol *</strong>
                    </div>
                    <MDBInput
                      type="text"
                      {...register("brand_details.stock_symbol", {
                        required: "Stock Symbol is required",
                      })}
                    />
                    {errors?.brand_details?.stock_symbol && (
                      <p className="text-danger">
                        {errors?.brand_details?.stock_symbol?.message}
                      </p>
                    )}
                  </div>
                </MDBCol>
              )}
            </MDBRow>
          </div>
        </MDBCol>
      </MDBRow>

      <Tooltip
        anchorSelect=".LegalCompany"
        place="right"
        className="exampleTooltip"
      >
        Type the legally registered company name.
      </Tooltip>
      <Tooltip
        anchorSelect=".DBAorBrandName"
        place="right"
        className="exampleTooltip"
      >
        Type in the 'Doing Business As' (DBA) <br /> or trade name of the
        company.
      </Tooltip>
      <Tooltip
        anchorSelect=".CountryofRegistration"
        place="right"
        className="exampleTooltip"
      >
        Select the country in which the company is located
      </Tooltip>
      <Tooltip
        anchorSelect=".TaxNumber"
        place="right"
        className="exampleTooltip"
      >
        Please enter the 9-digit Tax Number/ID/EIN <br /> that has been issued
        by your country.
      </Tooltip>
      <Tooltip
        anchorSelect=".DUNSorGIIN"
        place="right"
        className="exampleTooltip"
      >
        Please select an "Alternative Business ID". <br /> You can provide the
        DUNS Number, GIIN, or LEI. This is a complementary and optional field{" "}
        <br /> to help better identify the Brand. The "DUNS Number" <br /> in
        particular is important in identifying non-US Brands.
      </Tooltip>
      <Tooltip
        anchorSelect=".DUNSNumber"
        place="right"
        className="exampleTooltip"
      >
        Please enter the "Alternative Business ID". <br /> This is a
        complementary and optional field to better identify the Brand.
      </Tooltip>
      {displayalert && (
        <PopupLoader
          title="Alert"
          content={
            <>
              <div>
                <span className="phrecording">
                  We are unable to create a brand with Organization type as
                  'Sole Proprietor'. Please contact Carrier Services
                  @800.619.3688 for further assistance.
                </span>
              </div>
              <MDBModalFooter>
                <MDBBtn onClick={(e) => handleOk(e)}>Ok</MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={setdisplayalert}
          onClose={alertToggle}
        />
      )}
    </>
  );
}

export default BrandDetails;
